var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: { filterable: "", placeholder: "请选择", clearable: "" },
      on: { change: _vm.changeSelect },
      model: {
        value: _vm.selectCompany,
        callback: function ($$v) {
          _vm.selectCompany = $$v
        },
        expression: "selectCompany",
      },
    },
    _vm._l(_vm.options, function (dict) {
      return _c("el-option", {
        key: dict.id,
        attrs: {
          label: dict.name,
          value: _vm.outName ? dict.id + "_" + dict.name : dict.id,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }